import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';

export const submitPromptForReviewPopUpStyles = {
	dialog: {
		'& .MuiDialog-paper': { backgroundColor: 'transparent' },
	},
	popUp: {
		width: '583px',
		padding: '24px',
		borderRadius: '12px',
		border: `1px solid ${colorPalette.dark2}`,

		backgroundColor: `${colorPalette.dark5}`,

		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',

		textAlign: 'center',
	},
	submitPromptForReviewPopUp: {
		'& .lottie-cont': {
			height: '87px',

			display: 'flex',
			alignItems: 'center',
		},
	},
	textFlexCol: {
		margin: '24px 0 32px',

		...reusableStyles.flexCol,
		gap: '6px',
	},
	okayButton: {
		minWidth: '328px',
		padding: '10px 16px',
		borderRadius: '24px',

		color: 'colors.dark6',
		backgroundColor: 'colors.light1',

		textTransform: 'none',

		'&.Mui-disabled': {
			color: 'colors.light5',
			backgroundColor: 'colors.dark2',
		},
		'&:hover': { backgroundColor: 'colors.light1' },
	},
};
